import './heading/home-heading/home-heading';
import './media/gallery/gallery';
import './text/text-stats/text-stats';
import './text/text-before-after/text-before-after';

